@if (userForm) {
  <form [formGroup]="userForm" (save)="saveUser()">
    <h2>EDIT USER - {{ data.user ? data.user['id'] : '' }}</h2>
    <input type="hidden" [formControlName]="'id'" />
    <input type="hidden" [formControlName]="'Title'" />
    <mat-form-field class="col-3">
      <mat-label>User Name</mat-label>
      <input
        matInput
        readonly
        [formControlName]="'userName'"
        [placeholder]="'User Name'"
      />
    </mat-form-field>
    <mat-form-field class="col-3">
      <mat-label>Login Name</mat-label>
      <input
        matInput
        [formControlName]="'loginName'"
        [placeholder]="'Login Name'"
      />
    </mat-form-field>
    <mat-form-field class="col-3">
      <mat-label>First Name</mat-label>
      <input
        matInput
        [formControlName]="'firstName'"
        [placeholder]="'First Name'"
        [required]="true"
      />
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    <mat-form-field class="col-3">
      <mat-label>Last Name</mat-label>
      <input
        matInput
        [formControlName]="'lastName'"
        [placeholder]="'Last Name'"
        [required]="true"
      />
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    <mat-form-field class="col-3">
      <mat-label>Email</mat-label>
      <input
        matInput
        [formControlName]="'email'"
        [placeholder]="'Email'"
        [required]="true"
      />
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    <mat-form-field class="col-3">
      <mat-label>Save Type</mat-label>
      <mat-select required [formControlName]="'saveType'">
        <mat-option value="0">None</mat-option>
        <mat-option value="1">Permanent</mat-option>
        <mat-option value="2">Override</mat-option>
      </mat-select>
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    <mat-form-field class="col-3">
      <mat-label>Active</mat-label>
      <mat-select required [formControlName]="'isactive'">
        <mat-option value="1">Yes</mat-option>
        <mat-option value="0">No</mat-option>
      </mat-select>
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    <span class="col-3">
      <mat-checkbox [formControlName]="'producer'">Is Producer</mat-checkbox>
    </span>
    <mat-form-field class="col-6">
      <mat-label>Units Managed</mat-label>
      <mat-chip-grid #unitList aria-label="Units Managed">
        @for (unit of units; track unit) {
          <mat-chip-row
            [removable]="removable"
            (removed)="removeItem(unit, units)"
          >
            {{ unit }}
            @if (removable) {
              <mat-icon matChipRemove>cancel</mat-icon>
            }
          </mat-chip-row>
        }
        <input
          placeholder="Units Managed..."
          #unitInput
          [formControl]="unitCtrl"
          [matAutocomplete]="autoUnit"
          [matChipInputFor]="unitList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="addItem($event, units, unitCtrl)"
          (click)="focusUnits()"
        />
      </mat-chip-grid>
      <mat-autocomplete
        #autoUnit="matAutocomplete"
        (optionSelected)="selectedUnit($event)"
      >
        @if (unitDropdownLoading) {
          <mat-option disabled class="dropdownLoadingSpinner"
            ><mat-spinner diameter="48"></mat-spinner
          ></mat-option>
        }
        @if (unitDropdownNoResults) {
          <mat-option disabled>No Results</mat-option>
        }
        @if (!unitDropdownLoading && !unitDropdownNoResults) {
          @for (unit of filteredUnits; track $index) {
            <mat-option [value]="unit">
              {{ unit.id }}: {{ unit.name }}
            </mat-option>
          }
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="col-6">
      <mat-label>Roles</mat-label>
      <mat-chip-grid #roleList aria-label="Roles">
        @for (role of roles; track role) {
          <mat-chip-row
            [removable]="removable"
            (removed)="removeItem(role, roles)"
          >
            {{ role }}
            @if (removable) {
              <mat-icon matChipRemove>cancel</mat-icon>
            }
          </mat-chip-row>
        }
        <input
          placeholder="Select Role..."
          #roleInput
          [formControl]="roleCtrl"
          [matAutocomplete]="autoRole"
          [matChipInputFor]="roleList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="addItem($event, roles, roleCtrl)"
          (click)="focusRoles()"
        />
      </mat-chip-grid>
      <mat-autocomplete
        #autoRole="matAutocomplete"
        (optionSelected)="selectedRole($event)"
      >
        @for (role of filteredRoles | async; track role) {
          <mat-option [value]="role">
            {{ role }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="col-6">
      <mat-label>Rep Codes</mat-label>
      <mat-chip-grid #repList aria-label="Rep selection">
        @for (rep of reps; track rep) {
          <mat-chip-row
            [removable]="removable"
            (removed)="removeItem(rep, reps)"
          >
            {{ rep }}
            @if (removable) {
              <mat-icon matChipRemove>cancel</mat-icon>
            }
          </mat-chip-row>
        }
        <input
          placeholder="Select Rep..."
          #repInput
          [formControl]="repCtrl"
          [matAutocomplete]="autoRep"
          [matChipInputFor]="repList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="addItem($event, reps, repCtrl)"
          (click)="focusReps()"
        />
      </mat-chip-grid>
      <mat-autocomplete
        #autoRep="matAutocomplete"
        (optionSelected)="selectedRep($event)"
      >
        @if (repDropdownLoading) {
          <mat-option disabled class="dropdownLoadingSpinner"
            ><mat-spinner diameter="48"></mat-spinner
          ></mat-option>
        }
        @if (repDropdownNoResults) {
          <mat-option disabled>No Results</mat-option>
        }
        @if (!repDropdownLoading && !repDropdownNoResults) {
          @for (rep of filteredReps; track $index) {
            <mat-option [value]="rep">
              {{ rep.repCode }}: {{ rep.name }}
            </mat-option>
          }
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="col-6">
      <mat-label>Proxy Users</mat-label>
      <mat-chip-grid #userList aria-label="User selection">
        @for (user of users; track user) {
          <mat-chip-row
            [removable]="removable"
            (removed)="removeItem(user, users)"
          >
            {{ user.name }}: {{ user.id }}
            @if (removable) {
              <mat-icon matChipRemove>cancel</mat-icon>
            }
          </mat-chip-row>
        }
        <input
          placeholder="Search For Proxy Users..."
          #userInput
          [formControl]="userCtrl"
          (keyup)="userLookAhead($event)"
          [matAutocomplete]="autoUser"
          [matChipInputFor]="userList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="addItem($event, users, userCtrl)"
        />
      </mat-chip-grid>
      <mat-autocomplete
        #autoUser="matAutocomplete"
        (optionSelected)="selectedUser($event)"
      >
        @for (user of filteredUsers; track $index) {
          <mat-option [value]="user">
            {{ user.name }}: <small>{{ user.id }}</small>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="col-3">
      <mat-label>Licenses</mat-label>
      <input
        matInput
        [formControlName]="'licenses'"
        [placeholder]="'Licenses'"
      />
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    <div class="col-12">
      @if (rights.includes('AddEditUsers')) {
        <button
          mat-raised-button
          class="pull-right"
          color="accent"
          (click)="saveUser()"
        >
          Save
        </button>
      }
      <button mat-raised-button class="pull-right me-2" (click)="cancel()">
        Cancel
      </button>
      @if (rights.includes('AddEditUsers')) {
        <button mat-button color="warn" (click)="deleteUser()"> Delete </button>
      }
      @if (rights.includes('ResetPassword')) {
        <button mat-button color="primary" (click)="resetPassword()">
          Reset Password
        </button>
      }
    </div>
  </form>
}
